// footer script

// suppress default refresh of subscription submission
const subscribeForms = document.querySelectorAll('form[action="/contact#contact_form"]');

subscribeForms.forEach((form) => {
  form.addEventListener("submit", async (e) => {
    // prevent page refresh
    e.preventDefault();

    // post form data in the background
    await fetch("/contact#contact_form", {
      method: "post",
      body: new FormData(form),
    })

    const subscribeSucceedText = form.closest("data-subscribe-form").querySelector("[data-subscribe-succeed-text]");
    
    // show successful text
    if (subscribeSucceedText.dataset.subscribeSucceedText === "hidden") {
      subscribeSucceedText.dataset.subscribeSucceedText = "show";
    }

  })
})
